import { Revision } from "../types/schemas";
import { TranscriptSelection } from "../types/types";
import { transformSelectionByOperation } from "./transform-selection-by-operation";

/**
 * Transform a selection based on a revision
 *
 * @param selection The transcript selection to transform
 * @param revision The revision to apply to the selection
 * @returns The transformed selection
 */
export function transformSelection(
  selection: TranscriptSelection | null,
  revision: Revision | null,
): TranscriptSelection | null {
  if (!selection) return selection;
  if (!selection.start || !selection.end) return selection;
  if (!revision) return selection;

  let transformedSelection: TranscriptSelection | null = selection;
  // Apply each operation in the revision sequentially
  for (const op of revision.operations) {
    transformedSelection = transformSelectionByOperation(
      transformedSelection,
      op,
    );
  }

  return transformedSelection;
}
